import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { illustrationKeys } from './queryKeys';

export function registerIllustrationsEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('books.created', {
    getQueryKeys: (p) => [
      illustrationKeys.list(p.familyId as string),
      illustrationKeys.byStory(p.storyId as string),
    ],
  });

  register('books.updated', {
    getQueryKeys: (p) => [
      illustrationKeys.detail(p.bookId as string),
      illustrationKeys.list(p.familyId as string),
      [...illustrationKeys.all, 'byStory'],
    ],
  });

  register('books.deleted', {
    getQueryKeys: (p) => [illustrationKeys.list(p.familyId as string)],
  });

  // Per-item events: only invalidate detail (lightweight).
  // StoryWorkspace has its own SSE listeners that invalidate byStory(storyId) directly.
  // The staleTime: 500ms on byStory query batches rapid events.
  register('books.page.image-completed', {
    getQueryKeys: (p) => [illustrationKeys.detail(p.bookId as string)],
  });

  register('books.page.image-failed', {
    getQueryKeys: (p) => [illustrationKeys.detail(p.bookId as string)],
  });

  register('books.character.reference-completed', {
    getQueryKeys: (p) => [illustrationKeys.detail(p.bookId as string)],
  });

  register('books.character.reference-failed', {
    getQueryKeys: (p) => [illustrationKeys.detail(p.bookId as string)],
  });

  // Terminal + rare (once per book): keep byStory so the book is pulled into the
  // hub even if its shell wasn't cached yet (the hub also patches it for instant
  // paint, but the invalidate is the safety net that guarantees appearance).
  /**
   * Liveness, not state: which step the engine is on for this book. Nothing in
   * the database changed, so nothing is invalidated — the progress panel listens
   * to it directly, so a step that runs for minutes still shows movement.
   */
  register('books.phase', { getQueryKeys: () => [] });

  register('books.cover.completed', {
    getQueryKeys: (p) => [
      illustrationKeys.detail(p.bookId as string),
      [...illustrationKeys.all, 'byStory'],
    ],
  });

  register('books.cover.failed', {
    getQueryKeys: (p) => [
      illustrationKeys.detail(p.bookId as string),
      [...illustrationKeys.all, 'byStory'],
    ],
  });
}
